import React, { useEffect, useState } from 'react';
import { api } from '../../../../lib/acceleratorApi';
import { EmptyState } from '../../shared/UI';
import { TrendingUp } from 'lucide-react';

const STAGES = ['Lead', 'Intro', 'Due Diligence', 'Term Sheet', 'Closed', 'Passed'];

export default function InvestorDealflowPage() {
  const [dealflow, setDealflow] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.getDealflow().then(setDealflow).finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const updateStage = async (id, stage) => {
    await api.updateDealflow(id, { stage });
    load();
  };

  if (loading) return <div className="text-white/40 py-12 text-center">Loading...</div>;

  return (
    <div className="space-y-4">
      <p className="text-sm text-white/50">Your investment pipeline, update deal stages as conversations progress.</p>
      {dealflow.length === 0 ? (
        <EmptyState message="No startups in your dealflow yet. Admin will add opportunities." />
      ) : (
        <div className="grid gap-4">
          {dealflow.map((d) => (
            <div key={d._id} className="bg-white/[0.02] border border-white/10 rounded-xl p-5">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
                <div className="flex items-start gap-4">
                  {d.startupId?.logo ? (
                    <img src={d.startupId.logo} alt="" className="w-14 h-14 rounded-xl object-cover" />
                  ) : (
                    <div className="w-14 h-14 rounded-xl bg-[#d42b92]/20 flex items-center justify-center"><TrendingUp className="w-6 h-6 text-[#ff8ec5]" /></div>
                  )}
                  <div>
                    <h3 className="font-semibold text-lg">{d.startupId?.name || 'Startup'}</h3>
                    <p className="text-sm text-white/50">{d.startupId?.industry} · {d.startupId?.stage}</p>
                    {d.notes && <p className="text-sm text-white/60 mt-2">{d.notes}</p>}
                  </div>
                </div>
                <select
                  className="bg-black/40 border border-white/10 rounded-lg px-3 py-2 text-white text-sm"
                  value={d.stage}
                  onChange={(e) => updateStage(d._id, e.target.value)}
                >
                  {STAGES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              {d.amount && <p className="text-xs text-white/40 mt-3">Amount: {d.amount}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
